<template>
    <div class="invalid-feedback" v-bind:class="[classstyle]">
        {{getError}}
    </div>
</template>

<script>
    export default {
        props: {
            classstyle: { default: function () { return ''; }},
            errors: {
                default: function () {
                    return new Array();
                }
            },
        },
        data: function(){
            return {
                realErrors:new Array()
            }
        },
        computed: {
            getError:function () {
                return this.realErrors.join(', ');
            }
        },
        watch: { 
        },
        mounted() {
            if (this.errors instanceof Array) {
                this.realErrors = this.errors;
            } else if (this.errors instanceof Object) {
                for(const k in this.errors) {
                    this.realErrors.push(this.errors[k]);
                }
            } else if (this.errors) {
                this.realErrors.push(this.errors);
            }
        },
        methods: {
        }
    }
</script>
<style lang="scss" scoped>
.invalid-feedback {
    display: block;
}
</style>